/**
 * @file template-editor-fields.ts
 * @description Каталог полей Handlebars-контекста рендера документов
 * (phase19.7) — зеркало DocumentRenderContext (document-render.service.ts).
 * Используется дропдауном «Вставить поле» визуального редактора.
 */

export interface TemplateFieldGroup {
  group: string;
  /** hint — где поле работает (для «Позиции» — только внутри items-строки). */
  hint?: string;
  items: { path: string; label: string }[];
}

export const TEMPLATE_FIELDS: TemplateFieldGroup[] = [
  {
    group: "Документ",
    items: [
      { path: "document.number", label: "Номер документа" },
      { path: "document.issuedAt", label: "Дата выставления" },
      { path: "document.totalGross", label: "Сумма (итого)" },
      { path: "document.totalVat", label: "Сумма НДС" },
      { path: "document.currency", label: "Валюта" },
      { path: "document.notes", label: "Примечания" },
    ],
  },
  {
    group: "Продавец",
    items: [
      { path: "seller.legalName", label: "Наименование" },
      { path: "seller.inn", label: "ИНН" },
      { path: "seller.kpp", label: "КПП" },
      { path: "seller.ogrn", label: "ОГРН/ОГРНИП" },
      { path: "seller.legalAddress", label: "Юр. адрес" },
      { path: "seller.bankDetails", label: "Банковские реквизиты" },
      { path: "seller.signerName", label: "Подписант (ФИО)" },
      { path: "seller.signerPosition", label: "Подписант (должность)" },
      { path: "seller.signerBasis", label: "Основание полномочий" },
    ],
  },
  {
    group: "Покупатель",
    items: [
      { path: "buyer.name", label: "Наименование/ФИО" },
      { path: "buyer.inn", label: "ИНН" },
    ],
  },
  {
    group: "Сделка",
    items: [
      { path: "deal.name", label: "Название сделки" },
      { path: "deal.expectedAmount", label: "Ожидаемая сумма" },
    ],
  },
  {
    group: "Позиция заказа",
    hint: "работают внутри строки «Таблицы позиций»",
    items: [
      { path: "index", label: "№ п/п" },
      { path: "name", label: "Наименование" },
      { path: "quantity", label: "Количество" },
      { path: "price", label: "Цена" },
      { path: "total", label: "Сумма" },
      { path: "vatRate", label: "Ставка НДС, %" },
    ],
  },
];
